import { render, staticRenderFns } from "./GlobalSettingsPage.vue?vue&type=template&id=10d2d6c7&"
import script from "./GlobalSettingsPage.vue?vue&type=script&lang=js&"
export * from "./GlobalSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports